import React, { useEffect, useRef, useState } from "react";
import blog_ver_mas from "../../assets/01_Home/Blog_CTA-Thumbnail.webp";
import { Link } from "react-router-dom";

/*eslint-disable */

const blogs: any = [
  {
    name: "Hyundai y la huella de carbono",
    category: "Noticias",
    asset: "./assets/01_Home/comunidad-hyundai-huella-carbono.webp",
  },
  {
    name: "Nombre de un testimonio en dos líneas",
    category: "Recomendaciones",
    asset: "./assets/01_Home/comunidad-hyundai-testimonio-doble-linea.webp",
  },
  {
    name: "Las ventajas de tener tu propio hyundai eléctrico en ...",
    category: "Comunidad Hyundai",
    asset: "./assets/01_Home/comunidad-hyundai-ventajas-vehiculo-electrico.webp",
  },
];

interface BlogComponentProps {
  newsForCategories: any
}

const BlogComponent: React.FC<BlogComponentProps> = ({newsForCategories}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Si el componente está intersectando, lo hacemos visible
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
        // Si el componente sale hacia arriba, removemos la clase
        else if (entry.boundingClientRect.top > 0) {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className="blog-home-component">
      <div
        className={`title-blog-home-component`}
        ref={ref}
      >
        Novedades y comunidad Hyundai
      </div>
      <div className={`items-blog-home-component`}>
        {newsForCategories.map((item: any, index: number) => (
          <Link key={index} to={`/noticias/${item?.category_id}/${item?.slug}`} className={`item-blog-home-component ${isVisible ? "visible" : ""}`}>
            {/* <div className="blur-layer"></div> */}
            <img src={`https://manager.hyundaicolombia.co/${item?.media_portrait?.url}`} alt="" />
            <div className="descripcion-item-blog-home-component">
              <div className="category-descripcion-item-blog-home-component">
                {item.category}
              </div>
              <div className="name-descripcion-item-blog-home-component">
                {item.title}
              </div>
            </div>
            {/* <div className="mascara-item-blog-home-component"></div> */}
          </Link>
        ))}
        <Link to={"/noticias"} className="item-vermas-blog-home-component">
          <img src={blog_ver_mas} alt="" />
          <div className="mascara-item-blog-home-component">
            Ver más noticias <br />
            sobre Hyundai
          </div>
        </Link>
      </div>
    </div>
  );
};

export default BlogComponent;
